/** Fired after the org databases list changes (create/delete); Sidebar listens to refetch. */
export const DATABASES_LIST_CHANGED_EVENT = 'veilstream:databases-changed'

export function notifyDatabasesListChanged(): void {
  window.dispatchEvent(new CustomEvent(DATABASES_LIST_CHANGED_EVENT))
}

/** Fired after database users change (create/delete); Sidebar listens to refetch the users list. */
export const DATABASE_USERS_LIST_CHANGED_EVENT = 'veilstream:database-users-changed'

export function notifyDatabaseUsersListChanged(): void {
  window.dispatchEvent(new CustomEvent(DATABASE_USERS_LIST_CHANGED_EVENT))
}
